import { render, staticRenderFns } from "./Casual.vue?vue&type=template&id=b6deb596&scoped=true&"
import script from "./Casual.vue?vue&type=script&lang=js&"
export * from "./Casual.vue?vue&type=script&lang=js&"
import style0 from "./Casual.vue?vue&type=style&index=0&id=b6deb596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6deb596",
  null
  
)

export default component.exports